import { ApiLegalEntitiesUrls } from '@api/actors/apiLegalEntitiesUrls';
import {
  ApiApplicationsUrls,
  ApiEditorsUrls,
} from '@api/applications/api.applications.urls';
import { ApiAuthUrls } from '@api/auth/api.auth.urls';
import { ApiFilesUrls } from '@api/files/api.files.urls';
import { ApiFundsUrls } from '@api/funds/api.funds.urls';
import { ApiUrlsUrls } from '@api/urls/api.urls.urls';
import { ApiUsersUrls } from '@api/users/api.users.urls';

export const ApiUrls = {
  auth: ApiAuthUrls,
  users: ApiUsersUrls,
  applications: ApiApplicationsUrls,
  applicationEditors: ApiEditorsUrls,
  files: ApiFilesUrls,
  urls: ApiUrlsUrls,
  legalEntities: ApiLegalEntitiesUrls,
  funds: ApiFundsUrls,
};
